import PropTypes from 'prop-types';
import Styled from './card-style';

/**
 * Card component.
 * @param {object} props The props.
 * @returns {JSX.Element} The rendered Card component.
 */
const Card = (props) => {
  const {
    children,
    className,
    headerTitle,
    HeaderIcon,
    disabled,
    width,
    height,
    minHeight,
    backgroundColor,
    padding,
    onClick,
    paddingHeader,
    hoverColor,
    margin,
    cursor,
    hover,
    marginHeader,
    borderRadius,
    bodyStyle,
    border,
  } = props;
  return (
    <Styled.Card
      $padding={padding}
      $borderRadius={borderRadius}
      $width={width}
      $height={height}
      $minHeight={minHeight}
      $hoverColor={hoverColor}
      $margin={margin}
      $cursor={cursor}
      $hover={hover}
      onClick={onClick}
      $backgroundColor={backgroundColor}
      className={disabled ? 'disabled' : className}
      $border={border}
    >
      {className === 'editMode' ? (
        <Styled.EditModeStyle>
          <span>Edit Mode</span>
        </Styled.EditModeStyle>
      ) : null}
      {headerTitle && (
        <Styled.CardHeader
          $paddingHeader={paddingHeader}
          $marginHeader={marginHeader}
        >
          {HeaderIcon && <HeaderIcon size={22} />}
          {headerTitle && <span>{headerTitle}</span>}
        </Styled.CardHeader>
      )}
      <Styled.CardBody $padding={padding} style={bodyStyle}>
        {children}
      </Styled.CardBody>
    </Styled.Card>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  paddingHeader: PropTypes.string,
  marginHeader: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  hoverColor: PropTypes.string,
  hover: PropTypes.bool,
  headerTitle: PropTypes.string,
  HeaderIcon: PropTypes.node,
  width: PropTypes.string,
  margin: PropTypes.string,
  cursor: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  padding: PropTypes.string,
  bodyStyle: PropTypes.shape({}),
  border: PropTypes.string,
};

Card.defaultProps = {
  hoverColor: '#fff',
  HeaderIcon: null,
  cursor: 'pointer',
  margin: '0',
  height: 'auto',
  minHeight: undefined,
  width: '100%',
  hover: false,
  paddingHeader: '0px',
  marginHeader: undefined,
  borderRadius: '0',
  backgroundColor: '#FFFFFF',
  headerTitle: undefined,
  className: '',
  padding: '',
  onClick: undefined,
  disabled: false,
  bodyStyle: {},
  border: undefined,
};

export default Card;
